export const getCentroid = (arr) => {
    const center = arr.reduce((x, y) => [x[0] + y[0] / arr.length, x[1] + y[1] / arr.length], [0, 0])
    return {
        "lat": center[1],
        "lng": center[0]
    }
}